/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Component, OnDestroy, OnInit } from "@angular/core";
import { Store, select } from "@ngrx/store";
import { ICONS } from "src/app/core/constants/icons";
import * as ButtonSelectionActions from "../../../../../state/actions/button-click.actions";
import { HISTORY_TAB_MENU_ITEMS } from "src/app/core/constants/menuItems";
import { HeaderService } from "src/app/core/services/header.service";
import { selectModuleName } from "src/app/state/reducer/buttons.reducer";
import { ButtonsState } from "src/app/state/buttons-state";

@Component({
  selector: "app-history-tabs",
  templateUrl: "./history-tabs.component.html",
  styleUrls: ["./history-tabs.component.scss"]
})

export class HistoryTabsComponent implements OnInit, OnDestroy {

  protected historyTabs = HISTORY_TAB_MENU_ITEMS;
  protected INFO_WHITE = ICONS.INFO_WHITE;

  private $moduleName = this.store.pipe(select(selectModuleName));

  private moduleNameChangedSubscription: any;
  private selectedModule: string = "";

  constructor(private store: Store<ButtonsState>,
    protected headerService: HeaderService) { }

  ngOnInit(): void {
    this.moduleNameChangedSubscription = this.$moduleName.subscribe(selectedModule => {
      this.selectedModule = selectedModule;

      if (this.selectedModule == "max-cafe") {
        this.headerService.setCurrentNavBarInfo("Pregled transakcija", ICONS.TRANSACTION_HISTORY);
      }
      else if (this.selectedModule == "betting") {
        this.headerService.setCurrentNavBarInfo("Pregled transakcija", ICONS.TRANSACTION_HISTORY);
      }
      else {
        this.headerService.setCurrentNavBarInfo("Pregled isteklih MBC bodova", ICONS.TRANSACTION_HISTORY_EXPIRED_MBC);
      }
      this.isButtonSelected(this.selectedModule);
    });
  }

  isButtonSelected(buttonName: string): boolean {
    return buttonName === this.selectedModule;
  }

  selectButton(buttonName: string): void {
    this.selectedModule = buttonName;
    this.store.dispatch(ButtonSelectionActions.STATUS_BAR_MODULE_SELECTED({ button: buttonName }));
  }

  ngOnDestroy(): void {
    this.moduleNameChangedSubscription.unsubscribe();
  }
}
